import script from "./exhibitionsAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./exhibitionsAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./exhibitionsAdminPage.vue?vue&type=style&index=0&id=292f6d02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-292f6d02"]])

export default __exports__